import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonConfigurationRoleOverview, CommonConfigurationRoleTopics } from "../../CommonComponents/CommonConfigurationRoleViews";

export const ConfigurationRolesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.roles.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationRoleOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationRoleTopics />;
    }
};
